import _storage from '@/js/storage';
import { setToken,getToken } from '@/utils/auth'


export default (function(context,factory){
    return factory();
})(window,function(){

    var kj_model = {};


    return kj_model;

});


// WEBPACK FOOTER //
// ./src/js/common.js